// The client's own plan, for its page and the dashboard card. A 403 (not the client's own contact) stays a 403 and
// the card simply does not show; a server error or no answer retries twice, then the page offers Riprova.
import { useQuery } from "@tanstack/react-query";
import { planService } from "../services/planService";
import { retryPlan } from "../utils/portalPlan";

export const portalPlanKey = (clientId: string) => ["portal-plan", clientId] as const;

export const usePortalPlan = (clientId: string) =>
  useQuery({ queryKey: portalPlanKey(clientId), queryFn: () => planService.plan(clientId), retry: retryPlan });
